import { AfterViewChecked } from '@angular/core';
import { Component } from '@angular/core';
import { ElementRef } from '@angular/core';
import { HostBinding } from '@angular/core';
import { Input } from '@angular/core';

import { UIStickPosition } from 'app/ui/core/position';

const ARROW_SIZE = 12;

@Component({
    selector: 'ui-tooltip',
    template: '<div [innerHTML]="content | safeHtml"></div>',
    styleUrls: ['tooltip.component.scss']
})
export class UITooltipComponent implements AfterViewChecked {

    @Input()
    content: string;

    @Input()
    hostElement: HTMLElement;

    @HostBinding('attr.position')
    @Input()
    position: UIStickPosition;

    private nativeElement() {
        return <HTMLElement>this._elementRef.nativeElement;
    }

    constructor(private _elementRef: ElementRef) {
    }

    ngAfterViewChecked() {
        const nativeElement = this.nativeElement();
        const hostRect = this.hostElement.getBoundingClientRect();
        switch (this.position) {
            case 'left':
                nativeElement.style.left = (hostRect.left - nativeElement.clientWidth - ARROW_SIZE) + 'px';
                nativeElement.style.top = (hostRect.top + 0.5 * (hostRect.height - nativeElement.clientHeight)) + 'px';
                break;
            case 'top':
                nativeElement.style.left = (hostRect.left + 0.5 * (hostRect.width - nativeElement.clientWidth)) + 'px';
                nativeElement.style.top = (hostRect.top - nativeElement.clientHeight - ARROW_SIZE) + 'px';
                break;
            case 'bottom':
                nativeElement.style.left = (hostRect.left + 0.5 * (hostRect.width - nativeElement.clientWidth)) + 'px';
                nativeElement.style.top = (hostRect.bottom + ARROW_SIZE) + 'px';
                break;
            default:
                nativeElement.style.left = (hostRect.right + ARROW_SIZE) + 'px';
                nativeElement.style.top = (hostRect.top + 0.5 * (hostRect.height - nativeElement.clientHeight)) + 'px';
        }
    }

    show() {
        if (this.content) {
            this.nativeElement().style.opacity = '1';
        }
    }

    hide() {
        this.nativeElement().style.opacity = '0';
    }
}
